export enum LoggerActionEnum {
  'CREATED' = 'Created',
  'MODIFIED' = 'Modified',
  'FILE_ACTION' = 'File Action',
  'STATUS' = 'Status',
  'CANCELLED' = 'Cancelled',
}

export type LoggerActivityTypes = 'CREATED' | 'MODIFIED' | 'FILE_ACTION' | 'STATUS' | 'CANCELLED';
